import React from "react";
import { ShareButton } from "./ShareButton";

export function FundraiserHeader({ title, description, heroImage, shareUrl }) {
  return (
    <section className="relative w-full flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt={title}
          className="w-full h-full object-cover animate__animated animate__fadeIn"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      <div className="absolute top-6 right-6 z-20">
        <ShareButton label="Share" variant="solid" url={shareUrl} title={title} />
      </div>

      <div className="relative z-10 w-full px-6 py-20 md:py-28 text-center">
        <div className="max-w-4xl mx-auto animate__animated animate__fadeIn">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
            {title}
          </h1>
          <p className="text-lg md:text-xl text-gray-100 max-w-2xl mx-auto">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}
